import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { FiExternalLink } from "react-icons/fi";
import { userIs401kRollIn } from "store/selectors/user";
import { paychexPortalSelector } from "store/selectors/auth0";
import type { RootState } from "types/state";

import IconBanner from "components/IconBanner";

const mapStateToProps = (state: RootState) => {
  return {
    isPaychex: userIs401kRollIn(state),
    paychexPortal: paychexPortalSelector(state),
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  title?: string;
  subheader?: string;
  disclaimer?: React.ReactNode;
  icon?: React.ReactNode;
  color?: string;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class Rollover401kProgressiveOnboarding extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render = () => {
    const { disclaimer, subheader } = this.props;

    return (
      <>
        <IconBanner
          icon={this.props.icon}
          color={this.props.color}
          title={this.props.title}
          subheader={
            disclaimer ? (
              <>
                {subheader}
                <span className="disclaimer banner-disclaimer">
                  {disclaimer}
                </span>
              </>
            ) : (
              subheader
            )
          }
          actionComponent={
            <a
              href={this.props.paychexPortal}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className="paychex-link">
                Go to Paychex Portal
                <FiExternalLink
                  color="white"
                  stroke="#FFFFFF"
                  size={14}
                  style={{
                    marginLeft: "5px",
                    position: "relative",
                    bottom: 2,
                  }}
                />
              </div>
            </a>
          }
        />
      </>
    );
  };
}

export default connector(withApollo<Props>(Rollover401kProgressiveOnboarding));
